module.exports = __webpack_public_path__ + "img/blue_130.4ae1e731.png";